import {INITIAL_INFO_LOAD} from '../actions';
import {ActionWithPayload} from './index';
import {InitInformation} from "@models/init-information.interface";
import {AppState} from "@store/reducers/index";


export interface InitialInfoState extends InitInformation {};

export function initialInfoReducer (
  state = {
    countries: [],
    delivery_types: [],
    distance: null,
    package_count: null,
    package_types: [],
    product_terms: [],
  }, action: ActionWithPayload<InitialInfoState>) {
  switch (action.type) {
    case INITIAL_INFO_LOAD:
      return action.payload;

    default:
      return state;
  }
}

export const selectInitialInfo = (state: AppState) => state.initialInfo;



// WEBPACK FOOTER //
// ./src/app/store/reducers/initial-info.reducer.ts